import { render, staticRenderFns } from "./TransactionFeeComponent.vue?vue&type=template&id=73f77f89&"
import script from "./TransactionFeeComponent.vue?vue&type=script&lang=js&"
export * from "./TransactionFeeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports